import { FeatureList } from 'core/constants/common';
import Feature from './feature';

export default class Archival extends Feature {
  constructor(disabledFeatures: string[]) {
    super(FeatureList.archival, disabledFeatures);
  }

  isAccessible(): boolean {
    return super.isRouteAccessible();
  }
}
